import moment from 'moment-timezone'
import clx from 'classnames'
import AntdDatePicker from '../../../../Common/AntdDatePicker/AntdDatePicker'
import { withFormError } from '../../../../Common/Form'
import styles from './DatePickerField.css'
import { ON_SHELVED_TS_OPTIONS } from '../../../Shared'
import { getDefaultListingOffShelvedTs } from '../../../../../lib/FormHelper'
import {
  getDefaultTimezoneMoment,
  getSecondSanitizedEdgeMoment
} from '../../../../../../lib/renderUtil'
moment.tz.setDefault('Asia/Taipei')
/**
 * 區間：今日 - 90天 ~ 今日 + 10年
 */
const withinAvailablePeriod = dateMoment => {
  const isAvailable = dateMoment
    .isBetween(
      getDefaultTimezoneMoment(ON_SHELVED_TS_OPTIONS.minDate),
      getDefaultTimezoneMoment(ON_SHELVED_TS_OPTIONS.maxDate)
    )

  return isAvailable
}

const timerPickerOptions = {
  // 秒數不需要
  format: 'HH:mm'
}

const defaultDisabledDate = (isOnShelvedTs, onShelvedTs) => dateMoment => {
  let disabled = false

  if (isOnShelvedTs) {
    // 開始時間
    // 今日 - 1年 ~ 今日 + 10年
    disabled = !withinAvailablePeriod(dateMoment)
  } else {
    // 結束時間
    // 今日 - 1年 ~ 今日 + 10年
    // 只能接受開始時間以後的時間
    const beforeOnShelvedTs = dateMoment <= moment(onShelvedTs)
    disabled = beforeOnShelvedTs || !withinAvailablePeriod(dateMoment)
  }

  return disabled
}

/**
 * the component for redux form Field
 */
const DatePickerField = props => {
  const {
    readOnly,
    input,
    triggerFieldChange,
    onShelvedTs,
    className,
    showToday,
    allowClear,
    disabledDate
  } = props

  // props from redux-form
  const {
    name: fieldName,
    onChange: onFieldChange,
    value: fieldValue
  } = input

  // form state 裡面的時間要轉成 moment Obj
  const fieldMoment = (fieldValue && fieldValue !== 'Invalid date')
    ? moment(fieldValue)
    : null

  const isOnShelvedTs = fieldName === 'listing.onShelvedTs'

  const customDisabledDate = disabledDate || defaultDisabledDate(isOnShelvedTs, onShelvedTs)

  return (
    <div data-role={props['data-role']}>
      <AntdDatePicker
        size='large'
        showToday={showToday}
        allowClear={allowClear}
        value={fieldMoment}
        disabled={readOnly}
        className={clx(
          className,
          styles.antdDatePicker
        )}
        showTime={timerPickerOptions}
        disabledDate={customDisabledDate}
        onChange={(date, dateString) => {
          const edge = isOnShelvedTs ? 'start' : 'end'
          const sanitizedMoment = getSecondSanitizedEdgeMoment(date, edge)
          onFieldChange(sanitizedMoment.format())

          if (isOnShelvedTs && !sanitizedMoment.isSame(fieldMoment)) {
            /**
               * 結束時間 預設為開始時間+365d
               */
            triggerFieldChange(
              'listing.offShelvedTs',
              getDefaultListingOffShelvedTs(sanitizedMoment)
            )
          }
        }}
      />
    </div>
  )
}

export default withFormError(DatePickerField)
